<template>
	<div class="body">
		<Header></Header>
		<div class="block">
			<div class="banner_contact"></div>
			<div class="menu_block">
				<div class="content flr">
					<div class="location">
						当前位置：
						<a href="/">首页</a>
						<i class="icon el-icon-arrow-right"></i>
						<a href="/contact">联系我们</a>
					</div>
				</div>
			</div>

			<div class="content">
				<div class="title_01 mt70">联系我们</div>
				<div class="map"></div>
				<ul class="address">
					<li><strong>山东中喆德元智能装备有限公司</strong></li>
					<li>电话：0533-5356548</li>
					<li>邮箱：zhongzhedeyuan@163.com</li>
					<li>地址：山东省泰安高新区泰山科技产业园9号</li>
				</ul>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from '../components/hearder.vue'
import Footer from '../components/footer.vue'
export default {
	components: {
		Header,
		Footer
	}
}
</script>

<style lang="less" scoped>
.map{
	width: 100%;
	height: 350px;
	margin-top: 50px;
	background: url('../images/map.png') no-repeat;
}
.address{
	line-height: 40px;
	margin-top: 40px;

	strong{
		color: #000;
		font-size: 20px;
		margin-bottom: 20px;
	}
}
</style>
